import React from "react";
import "./styles/Taskbar.css";
import { useState } from "react";
import ErrorWindow from "./ErrorWindow";
import Draggable from "react-draggable";
import WindowsXPForm from "./WindowsXPForm";

const Taskbar = ({ folders = [], trayData = [] }) => {
  const [openWindows, setOpenWindows] = useState([]);
  const [isInfoWindowOpen, setInfoWindowOpen] = useState(false);

  const handleIconClick = () => {
    setOpenWindows((prevWindows) => [
      ...prevWindows,
      { id: Date.now(), content: "Error Occurred!!!" },
    ]);
  };

  const handleClose = (id) => {
    setOpenWindows((prevWindows) =>
      prevWindows.filter((window) => window.id !== id)
    );
  };
  const handleInfoIconClick = () => {
    setInfoWindowOpen(true);
  };

  const closeInfoWindow = () => {
    setInfoWindowOpen(false);
  };

  return (
    <>
      {/* DESKTOP FOLDERS */}
      <div className="desktop">
        <div className="folders">
          {folders.map((folder, index) => (
            <Draggable key={index}>
              <div
                key={index}
                className="folder"
                onDoubleClick={handleIconClick}
              >
                <img
                  src={folder.icon}
                  className="folder-icon"
                  alt={folder.name}
                />
                {folder.name}
              </div>
            </Draggable>
          ))}
        </div>
      </div>

      {/* TASKBAR */}
      <div className="taskbar">
        <div className="start-button">
          <img
            src="./images/windows-xp-logo.png"
            alt="Start Button"
            className="start-icon"
          />
          Start
        </div>

        <div className="task-icons">
          {/* Add task icons here */}
          <img
            src="./images/game.png"
            alt="Application 1"
            className="task-icon"
            onDoubleClick={handleIconClick}
          />
          <img
            src="./images/folder 2.png"
            alt="Application 2"
            className="task-icon"
            onDoubleClick={handleIconClick}
          />

          <img
            src="./images/info icon.png"
            alt="contact me app"
            className="task-icon"
            onClick={handleInfoIconClick}
          />
          {/* Add more icons as needed */}
        </div>

        {/* SYSTEM TRAY ICONS */}
        <div className="system-tray">
          <img
            src="./images/bluetooth.png"
            alt="Notification Icon"
            className="system-tray-icon"
          />
          <img
            src="./images/printer.png"
            alt="Network Icon"
            className="system-tray-icon"
          />
        </div>
        {/* <div className="system-tray">
          {trayData.map((tray, index) => (
            <div key={index}>
              <img
                src={tray.icon}
                className="system-tray-icon"
                alt={`Tray Icon ${index}`}
              />
            </div>
          ))}
        </div> */}
      </div>

      {/* Render open windows */}
      {openWindows.map((window, index) => (
        <div className="error-container" key={window.id}>
          <Draggable>
            <div
              className="window"
              style={{
                top: 10 * index,
                right: 10 * index,
              }}
            >
              <div className="title-bar">
                <div className="title">Windows XP</div>
                <button
                  className="close-button"
                  onClick={() => handleClose(window.id)}
                >
                  X
                </button>
              </div>
              <div className="content">
                <p>{window.content}</p>
              </div>
            </div>
          </Draggable>
        </div>
      ))}
      {/* to display form */}
      {isInfoWindowOpen && (
        <div className="info-container">
          <Draggable>
            <WindowsXPForm onClose={closeInfoWindow} />
          </Draggable>
        </div>
      )}
    </>
  );
};

export default Taskbar;
